// extracted by mini-css-extract-plugin
export default {"record":"record-V77If","vin":"vin-pBj7z"};